import axios from "axios";
import apiErrorMessage from "../../util/apiErrorMessage";

const baseEndpoint = "/api/purchases";

const cancelFailed = { error: { message: "Unable to cancel payment intent" } };

const requestCancel = ({ paymentIntentId, clientSecret }) =>
  window
    .fetch(`${baseEndpoint}/paymentIntents/${paymentIntentId}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clientSecret }),
    })
    .then((response) => (response.ok ? {} : response.json()))
    .catch(() => cancelFailed);

export async function cancelPaymentIntent({ paymentIntentId, clientSecret }) {
  return paymentIntentId && clientSecret
    ? requestCancel({ paymentIntentId, clientSecret })
    : cancelFailed;
}

/*
 * saveAddresses attempts to save given addresses for a user
 */
export async function saveAddresses(addresses) {
  try {
    const { data } = await axios.post("/api/address", addresses);
    return data;
  } catch (err) {
    return {
      error: { message: apiErrorMessage(err, "Unable to save addresses") },
    };
  }
}
